import type { TimeOffDashboardAttentionItem, TimeOffDashboardUpcoming } from '../../../api/timeOff';

type DashboardEntryRow = Pick<
  TimeOffDashboardUpcoming | TimeOffDashboardAttentionItem,
  'employeeUpn' | 'employeeDisplayName' | 'startUtc' | 'endUtc'
>;

export function displayEmployeeName(item: DashboardEntryRow): string {
  return item.employeeDisplayName?.trim() || item.employeeUpn;
}

export function formatDashboardDateRange(item: DashboardEntryRow): string {
  const fmt = new Intl.DateTimeFormat(undefined, { month: 'short', day: 'numeric' });
  const start = fmt.format(new Date(item.startUtc));
  const end = fmt.format(new Date(item.endUtc));
  return start === end ? start : `${start} - ${end}`;
}
